import { render } from "./GivingMethodCard.vue?vue&type=template&id=09ce806f&scoped=true"
import script from "./GivingMethodCard.vue?vue&type=script&lang=js"
export * from "./GivingMethodCard.vue?vue&type=script&lang=js"

import "./GivingMethodCard.vue?vue&type=style&index=0&id=09ce806f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ce806f"]])

export default __exports__